import PracticesList from "../components/PracticesList/PracticesList";

export default function PracticesPage() {
    return <PracticesList />;
}
